let mobileControls = (function(){
	let _ShowMenu = {
		controler 	: '#toggle-menu',
		sidebar 	: '#sidebar',
		showmenu 	: false,
		toggle : function() {
			this.showmenu = !this.showmenu;

			if(this.showmenu){
				$(this.sidebar).addClass('show');
				$(this.controler).attr('aria-expanded', 'true');
			}else{
				$(this.sidebar).removeClass('show');
				$(this.controler).attr('aria-expanded', 'false');
			}

		}
	}

	$('#toggle-menu').click(function(){
		let app = document.getElementById('app');

		_ShowMenu.toggle();

		let bg = document.createElement('div');

		$(bg).addClass('bg-menu');

		$(bg).click(function(){
			_ShowMenu.toggle();

			$(this).fadeOut(400, function(){
				$(this).remove();
			});
		});

		app.appendChild(bg);
	});
})();